<wbo-edit-page #editPage (saving)="mixAndMatchSaving()" [title]="model.data.name">
    <fui-formation-group class="basic-group no-header">
        <fui-rows [formGroup]="editPage.formGroup">
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <fui-append-field>
                            <wbo-text-edit-control formControlName="name"
                                                   [(ngModel)]="model.data.name"></wbo-text-edit-control>
                            <wbo-entity-discontinued-edit-control
                                formControlName="discontinued"
                                [(ngModel)]="model.data.discontinued"></wbo-entity-discontinued-edit-control>
                        </fui-append-field>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
        </fui-rows>
    </fui-formation-group>
    <fui-formation-group-template
        *formationGroup="{
            title: 'wbo.mix-and-match.edit.formation.applicability',
            formControlNames: [
                'doNotAutomaticallyApply',
                'triggerQty',
                'trxLimit',
                'priority'
            ]
        }">
        <fui-rows [formGroup]="editPage.formGroup">
            <fui-row>
                <fui-four-columns>
                    <fui-column>
                        <fui-radio-control [name]="'doNotAutomaticallyApply'"
                                           [ngModelOptions]="{standalone: true}" [equivalent]="false"
                                           [label]="'wbo.mix-and-match.edit.option.doNotAutomaticallyApply.false'"
                                           [(ngModel)]="model.data.doNotAutomaticallyApply"></fui-radio-control>
                        <fui-radio-control [name]="'doNotAutomaticallyApply'"
                                           [ngModelOptions]="{standalone: true}" [equivalent]="true"
                                           [label]="'wbo.mix-and-match.edit.option.doNotAutomaticallyApply.true'"
                                           [(ngModel)]="model.data.doNotAutomaticallyApply"></fui-radio-control>
                    </fui-column>
                    <fui-column class="three-col">
                        <fui-inline-information *ngIf="!model.data.doNotAutomaticallyApply"
                                                [title]="'wbo.common.info.information'"
                                                [message]="'wbo.mix-and-match.edit.message.automaticallyApply'"></fui-inline-information>
                        <fui-inline-information *ngIf="model.data.doNotAutomaticallyApply"
                                                [title]="'wbo.common.info.information'"
                                                [message]="'wbo.mix-and-match.edit.message.doNotAutomaticallyApply'"></fui-inline-information>
                    </fui-column>
                </fui-four-columns>
            </fui-row>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <fui-tandem-field>
                            <wbo-numeric-edit-control formControlName="trxLimit"
                                                      [(ngModel)]="model.data.trxLimit"></wbo-numeric-edit-control>
                            <wbo-text-edit-control formControlName="priority"
                                                   [(ngModel)]="model.data.priority"></wbo-text-edit-control>
                        </fui-tandem-field>
                    </fui-column>
                    <fui-column *ngIf="model.data.doNotAutomaticallyApply">
                        <wbo-period-schedule-multi-select-edit-control formControlName="periodSchedules"
                                                                       [multiObjectValueType]="true"
                                                                       [(ngModel)]="model.data.periodSchedules"></wbo-period-schedule-multi-select-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <fui-two-columns>
                    <fui-column *ngIf="Plugin.LOYALTY | booleanConfig" formGroupName="memberLoyalty">
                        <wbo-membership-type-multi-select-edit-control formControlName="mixAndMatchMemberTypes"
                                                                       [includeGuestOption]="true"
                                                                       [(ngModel)]="model.data.memberLoyalty.mixAndMatchMemberTypes"
                                                                       [multiObjectValueType]="true">
                        </wbo-membership-type-multi-select-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
        </fui-rows>
    </fui-formation-group-template>
    <fui-formation-group-template
        *formationGroup="{
            title: 'wbo.mix-and-match.edit.formation.discount',
            formControlNames: [
                'type',
                'priceLevel',
                'amount',
                'discountExtras'
            ]
        }">
        <fui-rows [formGroup]="editPage.formGroup">
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <fui-tandem-field>
                            <wbo-single-select-edit-control formControlName="type" [(ngModel)]="model.data.type"
                                                            (onSelect)="typeSelected($event)">
                                <wbo-select-options>
                                    <wbo-select-option [value]="MixAndMatchType.COMBINATION_PRICE"
                                                       label="wbo.mix-and-match.edit.option.type.combination-price">
                                    </wbo-select-option>
                                    <wbo-select-option [value]="MixAndMatchType.COMBINATION_DISCOUNT"
                                                       label="wbo.mix-and-match.edit.option.type.combination-discount">
                                    </wbo-select-option>
                                    <wbo-select-option [value]="MixAndMatchType.DISCOUNT_ALL_ITEMS"
                                                       label="wbo.mix-and-match.edit.option.type.discount-all-items">
                                    </wbo-select-option>
                                    <wbo-select-option [value]="MixAndMatchType.DISCOUNT_CHEAPEST"
                                                       label="wbo.mix-and-match.edit.option.type.discount-cheapest">
                                    </wbo-select-option>
                                    <wbo-select-option [value]="MixAndMatchType.DISCOUNT_MOST_EXPENSIVE"
                                                       label="wbo.mix-and-match.edit.option.type.discount-most-expensive">
                                    </wbo-select-option>
                                    <wbo-select-option [value]="MixAndMatchType.PRICE_LEVEL"
                                                       label="wbo.mix-and-match.edit.option.type.price-level">
                                    </wbo-select-option>
                                </wbo-select-options>
                            </wbo-single-select-edit-control>
                            <wbo-currency-edit-control
                                *ngIf="model.data.type === MixAndMatchType.COMBINATION_PRICE || model.data.type === MixAndMatchType.COMBINATION_DISCOUNT"
                                formControlName="amount"
                                [placeholder]="'wbo.mix-and-match.edit.field.amount.dollarPlaceholder'"
                                [overrideRequired]="true"
                                [(ngModel)]="model.data.amount"></wbo-currency-edit-control>
                            <wbo-numeric-edit-control
                                *ngIf="model.data.type !== MixAndMatchType.PRICE_LEVEL && model.data.type !== MixAndMatchType.COMBINATION_PRICE && model.data.type !== MixAndMatchType.COMBINATION_DISCOUNT"
                                formControlName="amount"
                                [placeholder]="'wbo.mix-and-match.edit.field.amount.percentagePlaceholder'"
                                [overrideRequired]="true"
                                [notation]="'%'"
                                [(ngModel)]="model.data.amount"></wbo-numeric-edit-control>
                            <ng-container *ngIf="model.data.type === MixAndMatchType.PRICE_LEVEL"
                                          formGroupName="priceLevel">
                                <wbo-price-level-single-select-edit-control formControlName="priceLevelId"
                                                                            [objectValue]="model.data.priceLevel"
                                                                            [overrideRequired]="true"
                                                                            [(ngModel)]="model.data.priceLevel.priceLevelId">
                                </wbo-price-level-single-select-edit-control>
                            </ng-container>
                        </fui-tandem-field>
                    </fui-column>
                    <fui-column>
                        <fui-prepend-field>
                            <fui-column>
                                <wbo-checkbox-edit-control formControlName="discountItem"
                                                           [(ngModel)]="model.data.discountItem"
                                                           (valueChange)="discountItemChanged()"></wbo-checkbox-edit-control>
                                <wbo-checkbox-edit-control formControlName="discountExtras"
                                                           [(ngModel)]="model.data.discountExtras"
                                                           (valueChange)="discountExtrasChanged()"></wbo-checkbox-edit-control>
                            </fui-column>
                            <fui-inline-warning *ngIf="model.data.discountExtras"
                                                [title]="'wbo.common.info.warning'"
                                                [message]="'wbo.mix-and-match.edit.message.discountExtras'"></fui-inline-warning>
                        </fui-prepend-field>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
        </fui-rows>
    </fui-formation-group-template>
    <fui-formation-group-template
        *formationGroup="{
            title: 'wbo.mix-and-match.edit.formation.itemInclusion',
            formControlNames: [
               'applyAcrossCourses',
               'applyToAllItemsAfterTrigger',
               'consumeMostExpensiveFirst',
               'inclusions'
            ]
        }">
        <fui-rows [formGroup]="editPage.formGroup">
            <fui-row>
                <fui-four-columns>
                    <fui-column>
                        <wbo-boolean-radio-edit-control [name]="'applyToAllProducts'"
                                                        [ngModelOptions]="{standalone: true}"
                                                        [trueLabel]="'wbo.mix-and-match.edit.option.applyToAllProducts.true'"
                                                        [falseLabel]="'wbo.mix-and-match.edit.option.applyToAllProducts.false'"
                                                        [(ngModel)]="applyToAllProducts"
                                                        [disabled]="editPageComponent?.editService.$entityRestricted | async"></wbo-boolean-radio-edit-control>
                    </fui-column>
                    <fui-column>
                        <wbo-numeric-edit-control formControlName="triggerQty"
                                                  [(ngModel)]="model.data.triggerQty"></wbo-numeric-edit-control>
                    </fui-column>
                    <fui-column>
                        <wbo-checkbox-edit-control formControlName="applyToAllItemsAfterTrigger"
                                                   [(ngModel)]="model.data.applyToAllItemsAfterTrigger"></wbo-checkbox-edit-control>
                        <wbo-checkbox-edit-control formControlName="applyAcrossCourses"
                                                   [(ngModel)]="model.data.applyAcrossCourses"></wbo-checkbox-edit-control>
                    </fui-column>
                    <fui-column>
                        <wbo-single-select-edit-control  *ngIf="(Config.MIX_AND_MATCH_ALLOW_CONSUME_MOST_EXPENSIVE | booleanConfig)"
                                                         formControlName="consumeMostExpensiveFirst"
                                                         [allowClearSelectionOption]="false"
                                                         [(ngModel)]="model.data.consumeMostExpensiveFirst">
                            <wbo-select-options>
                                <wbo-select-option [value]="false"
                                                   label="wbo.mix-and-match.edit.option.consumptionOrder.cheapestFirst">
                                </wbo-select-option>
                                <wbo-select-option [value]="true"
                                                   label="wbo.mix-and-match.edit.option.consumptionOrder.mostExpensiveFirst">
                                </wbo-select-option>
                            </wbo-select-options>
                        </wbo-single-select-edit-control>
                    </fui-column>
                </fui-four-columns>
            </fui-row>
            <fui-row *ngIf="!applyToAllProducts">
                <wbo-edit-grid #inclusionsGrid
                    [data]="model.data.inclusions" [editable]="true" [removable]="true"
                    [entityPath]="'inclusions'" [reorderable]="true" [forcePageable]="true"
                    (editFormClosed)="productsEditFormClosed($event)"
                    [endCommandColumnWidth]="64">
                    <wbo-mix-and-match-inclusion-edit-link-column></wbo-mix-and-match-inclusion-edit-link-column>
                    <wbo-text-column field="detail" [width]="250" [placeholder]="'\'\''"></wbo-text-column>
                    <wbo-currency-column field="price"></wbo-currency-column>
                    <wbo-checkbox-column field="required" [editable]="true"
                                         [width]="40"></wbo-checkbox-column>
                    <wbo-numeric-column field="minProductQty" [editable]="true"
                                        (valueChange)="minProductQtyChanged($event)"
                                        [placeholder]="'\'\''"
                                        [width]="70"></wbo-numeric-column>
                    <wbo-numeric-column field="maxProductQty" [editable]="true"
                                        (valueChange)="maxProductQtyChanged($event)"
                                        [placeholder]="'\'\''"
                                        [width]="70"></wbo-numeric-column>
                    <wbo-numeric-column field="discountableQty" [editable]="true"
                                        [placeholder]="'wbo.mix-and-match.edit.field.inclusions.discountableQty.placeholder'"
                                        [showPlaceholderForCell]="true"
                                        [width]="70"></wbo-numeric-column>
                    <wbo-edit-grid-add-row [customAdd]="true">
                        <wbo-edit-grid-add-row-quick-add (onSelect)="addFromInclusionSearchData($event)">
                            <wbo-mix-and-match-inclusion-single-select-edit-control></wbo-mix-and-match-inclusion-single-select-edit-control>
                        </wbo-edit-grid-add-row-quick-add>
                        <wbo-edit-grid-add-row-actions>
                            <wbo-edit-grid-add-row-search
                                [title]="'wbo.mix-and-match.edit.grid-add.inclusions.addProductLines'"
                                [searchComponent]="ProductLineSearchPageComponent"
                                (onSelect)="addFromSellable($event)"></wbo-edit-grid-add-row-search>
                            <wbo-edit-grid-add-row-search
                                [title]="'wbo.mix-and-match.edit.grid-add.inclusions.addCompositeProducts'"
                                [searchComponent]="CompositeProductSearchPageComponent"
                                (onSelect)="addFromSellable($event)"></wbo-edit-grid-add-row-search>
                            <wbo-edit-grid-add-row-search
                                [title]="'wbo.mix-and-match.edit.grid-add.inclusions.addCustomProductGroups'"
                                [searchComponent]="ProductLineCustomObjectSearchPageComponent"
                                (onSelect)="addFromCustomProductGroup($event)"></wbo-edit-grid-add-row-search>
                            <wbo-edit-grid-add-row-new-entity
                                [title]="'wbo.mix-and-match.edit.grid-add.inclusions.newProductLine'"
                                [editComponent]="ProductLineEditPageComponent"
                                (onSelect)="addFromSellable([$event])"></wbo-edit-grid-add-row-new-entity>
                            <wbo-edit-grid-add-row-new-entity
                                [title]="'wbo.mix-and-match.edit.grid-add.inclusions.newCompositeProduct'"
                                [editComponent]="CompositeProductEditPageComponent"
                                (onSelect)="addFromSellable([$event])"></wbo-edit-grid-add-row-new-entity>
                            <wbo-edit-grid-add-row-new-entity
                                [title]="'wbo.mix-and-match.edit.grid-add.inclusions.newCustomProductGroup'"
                                [editComponent]="ProductLineCustomObjectEditPageComponent"
                                (onSelect)="addFromCustomProductGroup([$event])"></wbo-edit-grid-add-row-new-entity>
                        </wbo-edit-grid-add-row-actions>
                    </wbo-edit-grid-add-row>
                    <ng-template gridFormTemplate let-dataItem="dataItem" let-formGroup="formGroup" let-isNew="isNew">
                        <wbo-mix-and-match-inclusion-edit-form [mixAndMatch]="model.data" [inclusion]="dataItem"
                                                               [formGroup]="formGroup"></wbo-mix-and-match-inclusion-edit-form>
                    </ng-template>
                </wbo-edit-grid>
            </fui-row>
            <fui-row *ngIf="complexityAnalysis.complexity === MixAndMatchComplexity.INDETERMINATE || complexityAnalysis.complexity === MixAndMatchComplexity.SINGLE_INTERSECTION || complexityAnalysis.complexity === MixAndMatchComplexity.MULTIPLE_INTERSECTIONS">
                <fui-column>
                    <fui-inline-warning
                        *ngIf="complexityAnalysis.complexity === MixAndMatchComplexity.INDETERMINATE"
                        [title]="'wbo.common.info.warning'"
                        [message]="'wbo.mix-and-match.edit.message.indeterminate'"
                        [messageParams]="{'limit': complexityAnalysis.limit}">
                    </fui-inline-warning>
                    <fui-inline-warning
                        *ngIf="complexityAnalysis.complexity === MixAndMatchComplexity.SINGLE_INTERSECTION"
                        [title]="'wbo.common.info.warning'"
                        [message]="'wbo.mix-and-match.edit.message.singleIntersection'"
                        [messageParams]="{'intersections': '&emsp;&#x25CF;&emsp;' + intersectionMessages.join('<br>&emsp;&#x25CF;&emsp;')}">
                    </fui-inline-warning>
                    <fui-inline-error
                        *ngIf="complexityAnalysis.complexity === MixAndMatchComplexity.MULTIPLE_INTERSECTIONS"
                        [title]="'wbo.common.info.warning'"
                        [message]="'wbo.mix-and-match.edit.message.multipleIntersections'"
                        [messageParams]="{'intersections': '&emsp;&#x25CF;&emsp;' + intersectionMessages.join('<br>&emsp;&#x25CF;&emsp;')}">
                    </fui-inline-error>
                </fui-column>
            </fui-row>
        </fui-rows>
    </fui-formation-group-template>
    <ng-container *ngIf="editPage.editMode !== EditMode.ADD">
        <fui-formation-group-template
            *formationGroup="{title: 'wbo.mix-and-match.edit.formation.schedules', formControlNames: 'schedules'}">
            <wbo-edit-grid [data]="model.data.schedules"
                           [editable]="true"
                           [removable]="true"
                           [customRemovable]="true"
                           [rowRemovable]="scheduleRowRemovable"
                           (customRemoving)="discontinueSchedule($event)"
                           [entityPath]="'schedules'">
                <wbo-edit-link-column field="name" [showDiscontinued]="true"
                                      [editComponent]="MixAndMatchScheduleEditPageComponent"
                                      [parentEntity]="model.data"></wbo-edit-link-column>
                <wbo-translated-column [title]="'wbo.pricing.schedule.column.description'"
                                       [messageRetriever]="PricingScheduleSummaryData.getDescriptionMessage"></wbo-translated-column>
                <wbo-edit-grid-add-row [identifierField]="'mixAndMatchScheduleId'">
                    <wbo-edit-grid-add-row-actions>
                        <wbo-edit-grid-add-row-new-entity
                            [editComponent]="MixAndMatchScheduleEditPageComponent"
                            [parentEntity]="model.data"></wbo-edit-grid-add-row-new-entity>
                    </wbo-edit-grid-add-row-actions>
                </wbo-edit-grid-add-row>
            </wbo-edit-grid>
        </fui-formation-group-template>
    </ng-container>
    <fui-formation-group-template
        *formationGroup="{
            title: 'wbo.mix-and-match.edit.formation.description',
            formControlNames: [
                'description',
                'externalDescription'
            ]
        }">
        <fui-rows>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <ng-container [formGroup]="editPage.formGroup">
                            <wbo-textarea-edit-control formControlName="description"
                                                       [(ngModel)]="model.data.description"></wbo-textarea-edit-control>
                        </ng-container>
                    </fui-column>
                    <fui-column>
                        <ng-container [formGroup]="editPage.formGroup">
                            <wbo-textarea-edit-control formControlName="externalDescription"
                                                       [(ngModel)]="model.data.externalDescription"></wbo-textarea-edit-control>
                        </ng-container>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
        </fui-rows>
    </fui-formation-group-template>
</wbo-edit-page>
